import Ingestion from "./ingestion";

export default {
  Ingestion
};
